import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumAssemblyRecipeType implements BaseEnumType {
  private static allValues: EnumAssemblyRecipeType[] = []; // make sure this is top-most
  
  public static recipe = new EnumAssemblyRecipeType(0, "Recipe", "enum_assembly_recipe_type_recipe");
  public static packaging = new EnumAssemblyRecipeType(1, "Packaging", "enum_assembly_recipe_type_packaging");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumAssemblyRecipeType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isRecipe() { return this === EnumAssemblyRecipeType.recipe; }
  public isPackaging() { return this === EnumAssemblyRecipeType.packaging; }

  public static getValues(): readonly EnumAssemblyRecipeType[] {
    return EnumAssemblyRecipeType.allValues;
  }

  public static getValuesExcept0(): readonly EnumAssemblyRecipeType[] {
    return EnumAssemblyRecipeType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumAssemblyRecipeType {
    const found = EnumAssemblyRecipeType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumAssemblyRecipeType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumAssemblyRecipeType): EnumAssemblyRecipeType {
    const found = name ? EnumAssemblyRecipeType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumAssemblyRecipeType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumAssemblyRecipeType>): boolean {
    return this.key === other?.key;
  }
}